import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import tables from "../../../../Data/Tables/Inventory/Transfer/tables";
import headers from "../../../../Data/Tables/Inventory/Transfer/headers";
import transfer from "../../../../Data/transfer.json";
import branches from "../../../../Data/branch.json";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import toast from "react-hot-toast";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_transfers } from "../../../../Controllers/Inventory/Transfer";
import moment from "moment";
import DotIcon from "../../../../Assets/Svg/dot";

const InventoryTransferTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        product: tabledata?.product,
        date: tabledata?.date,
        type: tabledata?.type,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const products = await get_all_transfers(data);
      if (products?.status) {
        let data = [];

        products?.data?.data?.map((value, index) => {
          data?.push({
            path: `/app/inventory/transfer/view/${value?._id}`,
            Number: `#TR-${value?.number}`,
            Branch: value?.supplier?.name,
            Date: moment(value?.date).format("MMMM Do YYYY"),
            Due: moment(value?.due_date).format("MMMM Do YYYY"),
            Amount: value?.total?.toFixed(3),
            "Transfer Status": value?.received ? (
              <div className="flex">
                <div className={`my-auto pr-2 text-green-500`}>
                  <DotIcon width={10} height={10} />
                </div>
                <div>Accepted</div>
              </div>
            ) : (
              <div className="flex">
                <div className={`my-auto pr-2 text-red-500`}>
                  <DotIcon width={10} height={10} />
                </div>
                <div>Not-accepted</div>
              </div>
            ),
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/inventory/transfer/edit/${value?._id}`}
                id={value?._id}
                api="delete-transfer"
                actiondata={actiondata}
              />
            ),
          });
        });

        setPagination({
          currentPage: products?.data?.currentPage,
          totalCount: products?.data?.totalCount,
          totalPages: products?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default InventoryTransferTable;
